import { Box } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Layout } from '@roc/feature-app-core';
import { Paper, Tabs } from '@roc/ui';
import { observer } from 'mobx-react';
import { BalanceSheetReportGrid } from './balanceSheetReportGrid';
import { BalanceSheetReportTabs } from '../../utils/constants';
import { useBalanceSheetReportStore } from '../../hooks/useBalanceSheetReportStore';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    maxWidth: '1400px',
  },
  paper: {
    boxShadow: 'none !important',
    border: '1px solid #cdcdcd',
    padding: '0px',
    borderRadius: '0 !important',
  },
}));

const TABS = [
  {
    value: BalanceSheetReportTabs.RENTAL_LOANS,
    label: 'Rental Loans',
  },
  {
    value: BalanceSheetReportTabs.BRIDGE_LOANS,
    label: 'Bridge Loans',
  },
  {
    value: BalanceSheetReportTabs.GROUND_UP_LOANS,
    label: 'Ground Up Loans',
  },
];

export const BalanceSheetReportDashboard = observer(() => {
  const classes = useStyles();
  const { balanceSheetReportStore } = useBalanceSheetReportStore();
  const { tab } = balanceSheetReportStore;

  return (
    <Layout title="Balance Sheet Report" containerClass={classes.container}>
      <Box pb={2}>
        <Tabs
          selectedTab={TABS.findIndex(t => t.value == tab)}
          tabs={Object.values(TABS)}
          onTabChange={(e, i) => balanceSheetReportStore.setTab(TABS[i].value)}
        />
      </Box>
      <Box display="flex" flexDirection="column" height="100%">
        <Box flex={1}>
          <Paper className={classes.paper}>
            <BalanceSheetReportGrid />
          </Paper>
        </Box>
      </Box>
    </Layout>
  );
});
